"use strict";
/*jshint esversion: 11 */

import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import PivotalApiEnvironments
  from "../../../js/csf/pivotal/PivotalApiEnvironments";

class CsfMembreNotificationsDataLayer {

  constructor(apiUrl, apiEnv, accessToken, fnApiCallbackError) {
    this.accessToken = accessToken;
    this.apiUrl = apiUrl;
    this.apiEnv = apiEnv;
    this.isInit = true;
    this.apiErrorCallback = fnApiCallbackError;
  }

  static getPeriodSubtitle(period, langCode) {
    return CsfMembreNotificationsDataLayer.ufcPeriodDateFormat(period?.Start_Date, langCode) + ' - ' + CsfMembreNotificationsDataLayer.ufcPeriodDateFormat(period?.End_Date, langCode);
  }

  static ufcPeriodDateFormat(dateString, langCode) {
    // langCode values to use: 'fr-FR' , 'en-US'

    if (dateString == null || dateString === '') {
      return '';
    }

    const date = new Date(dateString);

    const options = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    };

    return new Intl.DateTimeFormat(langCode, options).format(date);
  }


  fetchMemberInfo (setMemberInfoCallback) {
    const requestData = {
      search: 'Current_Ux_Client_User',
      searchResultsList: 'CSF_EM_Ux_Log_Contact_SRL'
    };
    const pivotalSearchApi = new PivotalSearchApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalSearchApi.callSearchEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length >= 0) {
          const memberInfo = response.payload.data.rows[0];
          setMemberInfoCallback(memberInfo);
        } else {
          console.log("Error fetching MemberInfo");
        }
      })
      .catch(error => {
        console.error(error);
        this.apiErrorCallback(error);
      });
  }

  fetchContactInfo(contactId, setUfcFileId, setNotificationsList) {

    const requestData = {
      form: 'CSF_EM_Contact_Info',
      recordId: contactId
    };
    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {

        if (response?.success && response?.payload?.data?.primary) {
          const contactInfo = response.payload.data.primary;

          if (contactInfo?.Education_File__Secondary?.length) {
            const fileSecondaryData = contactInfo?.Education_File__Secondary[0];
            let ufcFileId = '';
            if (fileSecondaryData?.Education_File_Id !== null) {
              ufcFileId = fileSecondaryData?.Education_File_Id;
            } else {
              // fallback pour anciens dossiers
              ufcFileId = fileSecondaryData?.REDU_Education_File_Id;
            }
            setUfcFileId(ufcFileId);
            this.fetchNotificationsInfo(ufcFileId, setNotificationsList);
          }
          else {
            console.error('CSF_EM_Contact_Info: No Education_File__Secondary in response.');
            this.apiErrorCallback('CSF_EM_Contact_Info: No Education_File__Secondary in response.');
          }

        }
      })
      .catch(error => {
        console.error(error);
        this.apiErrorCallback(error);
      });
  }

  fetchNotificationsInfo(EM_Education_File_Id, setNotificationsList) {

    if (EM_Education_File_Id === null) {
      console.error('EM_Education_File_Id is null');
      this.apiErrorCallback('EM_Education_File_Id is null');
      return;
    }

    const requestData = {
      form: 'CSF_EM_Notification_Info',
      recordId: EM_Education_File_Id
    };
    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormRecuperationEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success && response?.payload?.data?.primary) {
          setNotificationsList(response?.payload?.data?.primary?.Notification__Secondary);
          console.log(response?.payload?.data?.primary?.Notification__Secondary);
        }
      })
      .catch(error => {
        console.error(error);
        this.apiErrorCallback(error);
      });
  }

  submitNotifications(recordId, formData, submitCallback) {
    let requestData = {
      form: 'CSF_EM_Notification_REST',
      recordId: recordId,
      deltaData: formData
    };

    const pivotalFormApi = new PivotalFormApi(this.apiUrl, this.apiEnv, this.accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, PivotalApiEnvironments.getEspaceMembreSuffix())
      .then(response => {
        if (response?.success) {
          console.log("submitted successfully");
        } else {
          console.log("error in CSF_EM_Notification_REST");
        }
      })
      .catch(error => {
        console.log("error in CSF_EM_Notification_REST");
      });
  }

}

export default CsfMembreNotificationsDataLayer;
